import { gsap } from 'gsap';
export class PromoBanner {
    el;
    media;
    breadcrumb;
    title;
    subtitle;
    footer;
    constructor(el) {
        this.el = el;
        this.media = el.querySelector('img');
        this.breadcrumb = el.querySelector('.breadcrumb');
        this.footer = el.querySelector('footer');
        this.title = el.querySelector('h2');
        this.subtitle = el.querySelector('h4');
        this.init();
    }
    init() {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.el,
                toggleActions: 'restart none none reset'
            }
        });
        tl.add('start');
        if (this.media) {
            tl.fromTo(this.media, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
                duration: 0.25
            })
                .fromTo(this.media, {
                scaleX: 1.2,
                scaleY: 1.2,
                transformOrigin: '50% 50%',
            }, {
                scaleX: 1,
                scaleY: 1,
                transformOrigin: '50% 50%',
                duration: 0.5
            });
        }
        tl.add('end');
        if (this.title) {
            const elements = this.title.querySelectorAll('span');
            tl.fromTo(elements, {
                autoAlpha: 0,
                transform: 'translate3d(0, 100%, 0)'
            }, {
                duration: 0.75,
                transform: 'none',
                autoAlpha: 1,
                stagger: {
                    each: 0.06,
                    from: 'start'
                }
            }, 'end');
        }
        if (this.subtitle) {
            tl.fromTo(this.subtitle, {
                autoAlpha: 0,
                y: 8,
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.25,
                delay: 0.25
            }, 'end');
        }
        if (this.breadcrumb) {
            tl.fromTo(this.breadcrumb, {
                autoAlpha: 0,
                y: 8,
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.25,
                delay: 0.25
            }, 'end');
        }
        if (this.footer) {
            tl.fromTo(this.footer, {
                autoAlpha: 0,
                y: 16,
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.25,
                delay: 0.25
            }, 'end');
        }
    }
}
